import OrderNoteModal from './OrderNoteModal.vue';

export default OrderNoteModal;
